<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">流水单号:</span>
            <Input
              v-model.trim="table.params.bill_no"
              placeholder="流水单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="搜索 玩家ID"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">三方账号:</span>
            <Input
              v-model="table.params.external_account"
              placeholder="三方账号"
              clearable
            ></Input>
          </label>
        </Col>

        <!-- <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              :max-tag-count="3"
              @on-change="getAppGenList"
            >
              <Option
                v-for="(item, index) in getAppList()"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col> -->
      </Row>
      <Row :gutter="24" style="margin-top: 20px">
        <!--        <Col span="4">-->
        <!--          <label style="display: flex; align-items: center">-->
        <!--            <span style="width: 140px">上级子商户ID:</span>-->
        <!--            <Input-->
        <!--              v-model="table.params.pid"-->
        <!--              placeholder="上级子商户ID"-->
        <!--              clearable-->
        <!--            ></Input>-->
        <!--          </label>-->
        <!--        </Col>-->
        <!-- <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">类型:</span>
            <Select
              v-model="table.params.query_type"
              filterable
              placeholder="选择类型"
              clearable
            >
              <Option
                v-for="item in select.Query_Type"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col> -->
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">子游戏名称:</span>
            <Select
              v-model="table.params.game_id"
              filterable
              placeholder="选择子游戏名称"
              clearable
            >
              <Option
                v-for="item in select.GameType_List"
                :value="item.value"
                :label="item.name"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">所属代理:</span>
            <Select
              id="first"
              v-model="table.params.app_id"
              filterable
              placeholder="筛选所属代理"
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>

        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">所属商户:</span>
            <Select
              v-model="table.params.general_id"
              filterable
              placeholder="筛选 商户"
              :max-tag-count="3"
              @on-change="updateGeneral"
              clearable
            >
              <Option
                v-for="(item, index) in select.general_list"
                :value="item.general"
                :label="item.general_name"
                :key="index"
              >
                {{ item.general_name }}
                <span style="color: #bbb">({{ item.general }})</span>
              </Option>
            </Select>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 20px">
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">所属子商户:</span>
            <Select
              v-model="table.params.pack_no"
              filterable
              placeholder="筛选 子商户"
              clearable
            >
              <Option
                v-for="(item, index) in getPackList()"
                :value="item.pack_no"
                :label="item.pack_name"
                :key="index"
              >
                {{ item.pack_name }}
                <span style="color: #bbb">({{ item.pack_no }})</span>
              </Option>
            </Select>
          </label>
        </Col>

        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">货币分类:</span>
            <Select
                v-model="table.params.currency_type"
                filterable
                placeholder="选择货币分类"
                clearable
            >
              <Option
                  v-for="item in currencyList"
                  :value="item.currency"
                  :label="item.name"
                  :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

        <Col span="8">
          <label style="display: flex; align-items: center">
            <span class="labelSpan">时间范围:</span>
            <DatePicker
              type="daterange"
              v-model="table.params.dataTime"
              :options="dateOptions"
              style="width: 100%"
            ></DatePicker>
          </label>
          <span class="tips">注： 时间范围不允许跨月</span>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 20px">
        <Col span="6" style="display: flex;">
          <Button type="primary" @click.native="searchData(true)">查询</Button>
          <Button type="error" @click.native="resetData()" style="margin-left: 10px;">重置</Button>
          <Button type="primary" @click.native="eleToExcel()" style="margin-left: 10px;"
          >导出excel</Button>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      ref="tableRef"
    ></Table>
    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pageSize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
import MulReportHeader from "./components/mul_report_header.vue";
import { TransTopReq } from "@/api/admin/risk";
import { mapState } from "vuex";
export default {
  name: 'APIReport2',
  components: { MulReportHeader },
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      all: {},
      tableMaxHeight: 0,
      select: {
        GameType_List: JSON.parse(localStorage.getItem('gameList')),
        Query_Type: [
          { name: '代理', value: 1 },
          { name: '商户', value: 2 },
          { name: '子商户', value: 3 },
          { name: '玩家', value: 4 }
        ],
        general_list: [],
        pack_list: []
      },
      //活动数据
      // GetZhuanPanActiveData
      table: {
        app_name: '',
        gp_name: '',
        params: {
          general_id: -1,
          platid: 0,
          app_id: -1,
          pack_no: -1,
          query_type: 1,
          bill_no: '',
          user_id: '',
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay(),
          ],
          currency_type: '',
        },
        data: [],
        columns: [
          this.getRenderColumn('bill_no', '流水单号', '注单的流水号', 200),
          this.getRenderColumn('user_id', '玩家ID', '显示玩家的ID'),
          this.getRenderColumn('user_name', '玩家昵称', '显示玩家的昵称'),
          this.getRenderColumn(
            'external_account',
            '三方账号',
            '显示三方过来的玩家账号'
          ),
          // this.getRenderColumn(
          //   "pack_no",
          //   "上级子商户ID",
          //   "显示上级账号的ID"
          // ),
          this.getRenderColumn(
            "game_name",
            "子游戏名称",
            "显示子游戏名称"
          ),
          this.getRenderColumn(
            "level",
            "子游戏房间",
            "显示子游戏房间"
          ),
          this.getRenderColumn(
            "general",
            "所属商户",
            "显示该玩家的所属商户账号"
          ),
          this.getRenderColumn(
            "pack_no",
            "所属子商户",
            "显示该玩家的所属子商户账号"
          ),
          this.getRenderColumn(
              "currency_type",
              "货币分类",
              "显示货币分类"
          ),
          this.getRenderColumn(
            "old_point",
            "玩家余额(变动前)",
            "显示玩家该次投注前的余额"
          ),
          this.getRenderColumn(
            "new_point",
            "玩家余额(变动后)",
            "显示玩家该次投注后的余额"
          ),
          this.getRenderColumn(
            "chang_point",
            "变动金额",
            "显示玩家该次投注前后变动的余额"
          ),
          this.getRenderColumn(
            "bet_point",
            "投注金额",
            "该次注单玩家投注金额"
          ),
          this.getRenderColumn(
            "code_point",
            "有效投注",
            "该次注单玩家有效投注金额（去除对压）"
          ),
          this.getRenderColumn(
            "hit_point",
            "返奖金额",
            "该次注单玩家返奖金额"
          ),
          this.getRenderColumn(
            "flow_point",
            "游戏盈亏",
            "该次注单玩家盈亏金额（投注金额-返奖金额）"
          ),
          this.getRenderColumn(
            "percent_point",
            "游戏税收",
            "该次注单系统收取的税收金额"
          ),
          this.getRenderColumn(
            "ip",
            "用户所在IP",
            "显示该玩家投注时的IP地址"
          ),
          this.getRenderColumn(
            "time",
            "变更时间",
            "显示该笔注单发送变更的时间"
          ),
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pageSize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      }
    }
  },
  computed: {
    ...mapState({
      currencyList: state => state.app.globalCurrencyList
    }),
  },
  methods: {
    getRenderColumn(key, title, tip, width = 90) {
      return {
        key,
        width,
        align: 'center',
        resizable: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) => this.renderCol(h, params)
      }
    },
    //查询数据
    searchData(reset) {
      if (reset) {
        this.page.currentPage = 1
      }
      let stime = this.getSecond(this.table.params.dataTime[0])
      let etime = this.getSecond(this.table.params.dataTime[1], false)
      let pack_no =
        this.table.params.pack_no === undefined ? -1 : this.table.params.pack_no
      this.timestamp = new Date().getTime()
      let params = this.getTransTopParams('GetNewPlatfromData', {
        app_id: Number(this.table.params.app_id),
        stime,
        etime,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        general: this.table.params.general_id
          ? this.table.params.general_id
          : -1,
        pack_no,
        bill_no: this.table.params.bill_no,
        query_type: this.table.params.query_type
          ? Number(this.table.params.query_type)
          : 1,
        user_id: Number(this.table.params.user_id),
        external_account: this.table.params.external_account,
        game_id: this.table.params.game_id
          ? Number(this.table.params.game_id)
          : -1,
        game_level: '',
        currency_type: this.table.params.currency_type
      })
      this.table.data = []
      params.param._func = 'GetUserGameRecord'
      TransTopReq(params).then(res1 => {
        this.table.data = res1._param.list
        this.page.total = res1._param.total
      })
    },
    resetData() {
      const params = {
        page: 1,
        limit: 10,
        general: -1,
        pack_no: -1,
        query_type: 1,
        bill_no: '',
        user_id: '',
        game_id: -1,
        game_level: '',
        external_account: '',
        dataTime: [
          new Date(
            this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
          ),
          this.getCurrentZeroDay()
        ]
      }
      params.platid = this.getinitPlatId()
      params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
      this.table.params = params
      this.$nextTick(() => {
        this.searchData(true)
      })
    },
    renderCol(h, params) {
      let key = params.column.key
      let row = params.row

      if (key == 'external_account') {
        return this.renderNilData(h, params)
      }
      if (key.indexOf('point') != -1) {
        return this.renderMoney(h, params)
      }

      if (key === 'general') {
        const { general } = params.row
        const mapVal = this.select.general_list.filter(
          item => item.general == general
        )

        return h('span', mapVal[0].general_name + '(' + general + ')')
      }

      if (key === 'pack_no') {
        const { pack_no } = params.row
        const mapVal = this.select.pack_list.filter(
          item => item.pack_no == pack_no
        )

        return h('span', mapVal[0].pack_name + '(' + pack_no + ')')
      }
      return h('span', row[key])
    },
    getTableLength() {
      return Math.max(this.table.data.length - 1, 1)
    },
    getAppList() {
      return this.app_list.filter(el => this.table.params.platid == el.platform)
    },
    getAppGenList() {
      let params = this.getTransTopParams('GetAppGeneralList', {
        app_id: this.table.params.app_id,
        platid: this.table.params.platid,
        stime: this.getSecond(this.table.params.dataTime[0]),
        etime: this.getSecond(this.table.params.dataTime[1], false),
        page: this.page.currentPage,
        limit: 100,
        sort: 0,
        general: -1,
        pack_no: -1
      })
      this.select.general_list = []
      this.select.pack_list = []
      this.table.params.general_id = -1
      this.table.params.pack_no = -1
      TransTopReq(params).then(res => {
        this.select.general_list = res._param.general_list
        this.table.params.general_id = ''
        let params1 = this.copyData(params)
        params1.param._func = 'GetPackList'
        TransTopReq(params1).then(res => {
          this.select.pack_list = res._param.pack_list || []
        })
      })
    },
    updateGeneral() {
      this.table.params.pack_no = -1
    },
    getPackList() {
      return this.select.pack_list.filter(
        el => el.general == this.table.params.general_id
      )
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: this.table.params.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: {
            ...param
          }
        }
      }
    },
    updatePlat() {
      this.table.params.app_id = this.getAppList()[0]['appid']
      this.getAppGenList()
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
      this.getAppGenList()
    },
    pageChange(page) {
      this.page.currentPage = page
      this.searchData()
    },
    pageSizeChange(size) {
      this.page.pageSize = size
      this.searchData()
    },
    // 处理路由参数
    handleRouteParams() {
      const { user_id } = this.$route.query

      if (user_id) {
        this.table.params.user_id = user_id
      }
    }
  },
  activated() {
    this.handleRouteParams()
    this.initFunc()
    this.searchData()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 400
  }
}
</script>

<style scoped lang="less">
.labelSpan {
  margin-right: 10px;
  white-space: nowrap;
}

.tips {
  margin-left: 10px;
  color: red;
  font-size: 12px;
  white-space: nowrap;
}
</style>
